import type { ProductDetailsData, ProductDetailsProductData } from "@jti/fe-common";
import type { ApiMagentoConsumableMatrixItem, ApiMagentoConsumablesPackagingFormat } from "@jti/magento-types";

import type { LoyaltyBadgeCopyConfig, LoyaltyRewardCopyConfig } from "@product-details/components/ProductLoyaltyBlock";

export type ConsumableMatrixItem = ApiMagentoConsumableMatrixItem & {
  product: ProductDetailsProductData;
};

export type ConsumablesMatrixData = {
  packagingFormats: ApiMagentoConsumablesPackagingFormat[];
  items: ConsumableMatrixItem[];
};

export type ConsumablesProductDetailsData = Pick<
  ProductDetailsData,
  | "sku"
  | "badgeText"
  | "overwriteBadgeText"
  | "description"
  | "shortDescription"
  | "knowMoreUrl"
  | "multiPackDescription"
  | "productCta"
  | "productName"
  | "hasBadge"
  | "hasDiscountBadge"
  | "hasStrikethroughPrice"
  | "hideCta"
  | "isCommerceDisabled"
  | "isMultiPackEnabled"
  | "hidePrice"
  | "multiPackName"
  | "multiPackProducts"
  | "customBuyCtaLabel"
> & {
  hasLoyaltyDiscountBadge?: boolean;
  consumablesMatrixData: ConsumablesMatrixData;
  isSubscriptionsEnabled: boolean;
  isPriceDropdownEnabled?: boolean;
  priceDropdownPromotionalMessage?: string;
  priceDropdownPromotionalTooltip?: string;
  loyaltyBadgeCopy?: LoyaltyBadgeCopyConfig;
  loyaltyRewardCopy?: LoyaltyRewardCopyConfig;
  isLoyaltyRewardCopyAuthoringEnabled?: boolean;
};
